/* eslint-disable react/prop-types */
import { useTranslation } from 'react-i18next';
import { useFormState } from 'react-final-form';
import { useState } from 'react';
import { FormBlockWrapper } from '../FormBlockWrapper';
import { DealTypeTabs } from '../../../DealTypeTabs';
import { CategoriesSelect } from '../../components/CategoriesSelect';
import { Category } from '../../../../../graphql/types';
import { FORM_VALUES } from '../../../../../utils/helpers/constants';
import { SelectLocationMap } from '../../components/SelectLocationMap';
import { ContentWrapper } from './styled';
import { CitiesSelect } from '../../components/CitiesSelect';
import { RegionSelect } from '../../components/RegionSelect';
import { VillageSelect } from '../../components/VillageSelect';
import { InitCoordinatesType } from '../../components/types';
import { FormTextInput } from '../../components/FormTextInput';

interface MainFormBlockProps {
  citiesLoading: boolean;
  setCitiesIsLoading: React.Dispatch<React.SetStateAction<boolean>>;
  categories: Category[];
}

const ADDRESS_CHAR_LIMIT = '3000';

const tabsStats = [
  {
    value: 'false',
    dataStat: 'create_ad_step3_mode_sell'
  },
  {
    value: 'true',
    dataStat: 'create_ad_step3_mode_rent'
  }
];

export const MainFormBlock: React.FC<MainFormBlockProps> = ({
  citiesLoading,
  setCitiesIsLoading,
  categories
}) => {
  const { t } = useTranslation();
  const { values } = useFormState();
  const locationId = values[FORM_VALUES.locationId];
  const cityHasLocations = values[FORM_VALUES.cityHasLocations];

  const [initCoordinates, setInitCoordinates] = useState<InitCoordinatesType>();

  const isAddressShown = !citiesLoading && (!cityHasLocations || locationId);

  return (
    <FormBlockWrapper>
      <ContentWrapper data-cy="item-modal__type-deal">
        <DealTypeTabs dataStats={tabsStats} />
        <CategoriesSelect categories={categories} />
      </ContentWrapper>

      <CitiesSelect
        setCitiesLoading={setCitiesIsLoading}
        setInitCoordinates={setInitCoordinates}
      />

      {cityHasLocations && !citiesLoading && (
        <RegionSelect setInitCoordinates={setInitCoordinates} />
      )}

      {locationId && <VillageSelect setInitCoordinates={setInitCoordinates} />}

      {isAddressShown && (
        <>
          <FormTextInput
            name={FORM_VALUES.address}
            maxLength={ADDRESS_CHAR_LIMIT}
            placeholder={t('new_ad.address')}
            hasErrorField
          />
          <SelectLocationMap initialLocation={initCoordinates} />
        </>
      )}
    </FormBlockWrapper>
  );
};
